import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button as UiButton } from '../../ui/Button';

const SubmissionHeader = ({
    submission,
    isDark,
    userTeamData,
    timeLeft,
    formatDate,
    formatRemainingTime,
    handleCancelSubmission,
    navigate,
    isItUser,
    onUpdateUrl,
}) => {
    return (
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 sm:gap-0">
            {/* Left content with date and status */}
            <div className="flex flex-col gap-[6px]">
                <div className={`flex items-center gap-2 sm:gap-[6px] text-[17px] sm:text-[20px] font-semibold m-0 transition-colors duration-200 ${
                    isDark ? 'text-white' : 'text-[#072837]'
                }`}>
                    <button onClick={() => navigate('/submission?cleardata=false')} className="p-0 m-0 border-0 bg-transparent cursor-pointer shrink-0">
                        <ArrowLeft className={`w-5 h-5 sm:w-[20px] sm:h-[20px] transition-colors duration-200 ${
                            isDark ? 'text-white' : 'text-[#072837]'
                        }`} />
                    </button>
                    <span className="truncate">{formatDate(submission.createdAt)}</span>
                </div>
                <div className={`flex flex-wrap items-center gap-2 sm:gap-[8px] text-[14px] sm:text-[16px] m-0 transition-colors duration-200 ${
                    isDark ? 'text-[#b0b0b0]' : 'text-[#686868]'
                }`}>
                    <span>Submission ID: {submission.id}</span>
                    <span className="">-</span>
                    <span className={`transition-colors duration-200 ${
                        isDark ? 'text-[#b0b0b0]' : 'text-[#686868]'
                    }`}>Status:</span>
                    <span className={`inline-flex items-center justify-center rounded-[58px] px-[12px] py-[4px] text-[13px] font-semibold ${
                        submission.status === 'complete' ? 'bg-[#d9fbe6] text-[#0a6e29]' :
                        submission.status === 'cancelled' ? 'bg-[#ffe3e3] text-[#b42318]' :
                        submission.status === 'issues' ? 'bg-[#f9e3ff] text-[#7e22ce]' :
                        submission.status === 'error' ? 'bg-[#ffe0cc] text-[#c2410c]' :
                        submission.status === 'pending' ? 'bg-[#9A7B00] text-[#FFF9DB]' :
                        submission.status === 'scheduled' ? 'bg-[#3E62E2] text-[#DAE3FF]' :
                        'bg-[#f0f0f0] text-[#072837]'
                    }`}>{submission.status}</span>
                </div>
            </div>

            {/* Right-aligned button */}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-[12px] w-full sm:w-auto">
                {(submission.status === 'scheduled' || submission.status === 'pending') && timeLeft > 0 && (() => {
                    const isSuperAdmin = userTeamData?.user_role_id?.includes("11");
                    const isAdmin = userTeamData?.user_role_id?.includes("10");
                    const userOwnsSubmission = submission.user_team_id == userTeamData?.id || submission.email === userTeamData?.email;
                    if (isSuperAdmin) return true;
                    if (isAdmin) return submission.user_team_id == userTeamData?.id;
                    return userOwnsSubmission;
                })() && (
                    <UiButton
                        className="text-[14px] sm:text-[16px] font-semibold px-[16px] sm:px-[12px] py-[12px] sm:py-[12px] rounded-[12px] bg-[#FFE3E3] text-[#b42318] hover:bg-[#FFE3E3] cursor-pointer transition-colors duration-200 w-full sm:w-auto"
                        onClick={handleCancelSubmission}
                    >
                        {`Cancel Submission ${formatRemainingTime(timeLeft)}`}
                    </UiButton>
                )}

                {isItUser && submission.public_strata_url && (
                    <button
                        onClick={onUpdateUrl}
                        className="inline-flex items-center justify-center gap-[6px] rounded-[16px] font-semibold text-[14px] sm:text-[16px] border-0 cursor-pointer text-white px-[16px] py-[12px] w-full sm:w-auto transition-colors duration-200"
                        style={{ backgroundColor: '#0d2d4a' }}
                    >
                        <div
                            className="w-4 h-4 sm:w-[16px] sm:h-[16px] shrink-0"
                            style={{
                                backgroundColor: '#ffffff',
                                WebkitMaskImage: "url('/assets/icons/url-update.svg')",
                                WebkitMaskRepeat: 'no-repeat',
                                WebkitMaskSize: 'contain',
                                WebkitMaskPosition: 'center',
                                maskImage: "url('/assets/icons/url-update.svg')",
                                maskRepeat: 'no-repeat',
                                maskSize: 'contain',
                                maskPosition: 'center',
                            }}
                            aria-hidden="true"
                        />
                        Update URL
                    </button>
                )}

                {(submission.status === 'complete' || submission.status === 'issues' ||
                    (submission.status === 'error' && (userTeamData?.user_role_id?.includes("10") || userTeamData?.user_role_id?.includes("11")))) && (
                    <UiButton
                        variant="orange"
                        isDark={isDark}
                        size='sm'
                        className="w-full sm:w-auto py-[12px] sm:py-[12px]"
                        icon={
                            <div
                                className="w-4 h-4 sm:w-[16px] sm:h-[16px]"
                                style={{
                                    backgroundColor: isDark ? '#000000' : '#ffffff',
                                    WebkitMaskImage: "url('/assets/icons/logdata.svg')",
                                    WebkitMaskRepeat: 'no-repeat',
                                    WebkitMaskSize: 'contain',
                                    WebkitMaskPosition: 'center',
                                    maskImage: "url('/assets/icons/logdata.svg')",
                                    maskRepeat: 'no-repeat',
                                    maskSize: 'contain',
                                    maskPosition: 'center',
                                    transition: 'background-color 0.2s ease'
                                }}
                                aria-hidden="true"
                            />
                        }
                        onClick={() => navigate(`/submission-logs/${submission.id}`)}
                    >
                        View Submission Logs
                    </UiButton>
                )}
            </div>
        </div>
    );
};

export default SubmissionHeader;
